import { EventFilterModel } from "../../../../../shop/frontend/web/js/models/EventFilterModel";
import request from "../../../../../shop/frontend/web/js/api/request";

export class EventFrontendFilterModel extends EventFilterModel {
	constructor() {
		super();
	}

	/* Запросы к API */
	search(data) {
		return request({
			url: "/search",
			addCSRFToken: true,
			type: "POST",
			data: data,
		});
	}
}
